import {Injectable} from "@angular/core";
import { Observable, Subject } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  public TextParentObservable = new Subject<any>();
  public LinkParentObservable = new Subject<any>();

  public TextActualObservable = new Subject<any>();

  TextParent(val:any) {
    this.TextParentObservable.next(val);
  }
  LinkParent(val:any) {
    this.LinkParentObservable.next(val);
  }

  TextActual(val:any) {
    this.TextActualObservable.next(val);
  }

}

